import React from 'react';
import {EmailTemplateContainer} from '../../Containers/EmailContainer';

const EmailTemplate = (props) => {
	return (
		<EmailTemplateContainer page="list" />
	);
}

export default EmailTemplate;